import {
  GET_MAIN_PAGE_BUTTONS_STARTED,
  GET_MAIN_PAGE_BUTTONS_SUCCESS,
  GET_MAIN_PAGE_BUTTONS_FAILURE,
  GET_ALL_CONTENTS_FOR_EXPORT_STARTED,
  GET_ALL_CONTENTS_FOR_EXPORT_SUCCESS,
  GET_ALL_CONTENTS_FOR_EXPORT_FAILURE,
  RESET_CONTENTS_FOR_EXPORT,
  SEND_CONTENTS_FOR_IMPORT_STARTED,
  SEND_CONTENTS_FOR_IMPORT_SUCCESS,
  SEND_CONTENTS_FOR_IMPORT_FAILURE,
  GET_HELP_CONTENT_STARTED,
  GET_HELP_CONTENT_SUCCESS,
  GET_HELP_CONTENT_FAILURE,
  UPDATE_HELP_CONTENT_STARTED,
  UPDATE_HELP_CONTENT_SUCCESS,
  UPDATE_HELP_CONTENT_FAILURE,
  CREATE_HELP_CONTENT_STARTED,
  CREATE_HELP_CONTENT_SUCCESS,
  CREATE_HELP_CONTENT_FAILURE,
  DELETE_HELP_CONTENT_STARTED,
  DELETE_HELP_CONTENT_SUCCESS,
  DELETE_HELP_CONTENT_FAILURE,
  CLEAR_HELP_CONTENT,
} from './types';

import { fetchingError } from '../../../shared/store/actions';
import { errorNotification, successNotification } from '../../../shared/store/notificationActions';

import getPathnameForHelpContent from '../../helpMenu/utils/getPathnameForHelpContent';

import { RELEASE_NOTES_NAME } from '../../helpMenu/helpMenu.constants';

import {
  fetchHelpContent as fetchHelpContentApi,
  fetchAllContentsForExport as fetchAllContentsForExportApi,
  sendContentsForImport as sendContentsForImportApi,
  fetchMainPageButtons as fetchMainPageButtonsApi,
  updateHelpContent as updateHelpContentApi,
  createHelpContent as createHelpContentApi,
  deleteHelpContent as deleteHelpContentApi,
} from '../api';

import { fetchReleaseNotes } from '../../helpMenu/subsections/releaseNotes/store/actions';

export const fetchMainPageButtons = pageUrl => async dispatch => {
  try {
    dispatch({
      type: GET_MAIN_PAGE_BUTTONS_STARTED,
    });
    const mainPageButtons = await fetchMainPageButtonsApi(pageUrl);
    dispatch({
      type: GET_MAIN_PAGE_BUTTONS_SUCCESS,
      mainPageButtons,
    });
  } catch (error) {
    dispatch(fetchingError());
    dispatch({
      type: GET_MAIN_PAGE_BUTTONS_FAILURE,
    });
    dispatch(errorNotification(error.message));
  }
};

export const fetchHelpContent = (contentId, history) => async dispatch => {
  try {
    dispatch({
      type: GET_HELP_CONTENT_STARTED,
    });
    const helpContent = await fetchHelpContentApi(contentId);
    dispatch({
      type: GET_HELP_CONTENT_SUCCESS,
      helpContent,
    });
  } catch (error) {
    dispatch(fetchingError());
    dispatch({
      type: GET_HELP_CONTENT_FAILURE,
    });

    if (error?.isNotFoundError) {
      history?.replace('/not-found');
      return;
    }

    dispatch(errorNotification(error.message));
  }
};

export const fetchAllContentsForExport = () => async dispatch => {
  try {
    dispatch({
      type: GET_ALL_CONTENTS_FOR_EXPORT_STARTED,
    });
    const helpContents = await fetchAllContentsForExportApi();
    dispatch({
      type: GET_ALL_CONTENTS_FOR_EXPORT_SUCCESS,
      helpContents,
    });
  } catch (error) {
    dispatch(fetchingError());
    dispatch({
      type: GET_ALL_CONTENTS_FOR_EXPORT_FAILURE,
    });
    dispatch(errorNotification(error.message));
  }
};

export const resetContentsForExport = () => ({ type: RESET_CONTENTS_FOR_EXPORT });

export const sendContentsForImport = contents => async dispatch => {
  try {
    dispatch({
      type: SEND_CONTENTS_FOR_IMPORT_STARTED,
    });
    await sendContentsForImportApi(contents);
    dispatch({
      type: SEND_CONTENTS_FOR_IMPORT_SUCCESS,
    });
    dispatch(successNotification('Import successful'));
    dispatch(fetchMainPageButtons(getPathnameForHelpContent()));
  } catch (error) {
    dispatch(fetchingError());
    dispatch({
      type: SEND_CONTENTS_FOR_IMPORT_FAILURE,
    });
    dispatch(errorNotification(error.message));
  }
};


export const clearHelpContent = () => ({ type: CLEAR_HELP_CONTENT });

export const updateHelpContent = (contentId, {
  title,
  content,
  contentText,
  clients,
}) => async dispatch => {
  try {
    dispatch({
      type: UPDATE_HELP_CONTENT_STARTED,
    });
    await updateHelpContentApi(contentId, { title, content, contentText, clients });
    dispatch({
      type: UPDATE_HELP_CONTENT_SUCCESS,
    });
    dispatch(successNotification('Help updated'));
    dispatch(fetchMainPageButtons(getPathnameForHelpContent()));
  } catch (error) {
    dispatch(fetchingError());
    dispatch({
      type: UPDATE_HELP_CONTENT_FAILURE,
    });
    dispatch(errorNotification(error.message));
  }
};

export const createHelpContent = ({
  pageUrl = null,
  title,
  sectionName,
  settings,
}) => async dispatch => {
  try {
    dispatch({
      type: CREATE_HELP_CONTENT_STARTED,
    });
    const createHelpContentResults = await createHelpContentApi({ pageUrl, title, sectionName, settings });
    dispatch({
      type: CREATE_HELP_CONTENT_SUCCESS,
      createHelpContentResults,
    });
    dispatch(successNotification('Help added'));

    if (sectionName === RELEASE_NOTES_NAME) {
      dispatch(fetchReleaseNotes());
    } else {
      dispatch(fetchMainPageButtons(getPathnameForHelpContent()));
    }
  } catch (error) {
    dispatch(fetchingError());
    dispatch({
      type: CREATE_HELP_CONTENT_FAILURE,
    });
    dispatch(errorNotification(error.message));
  }
};

export const deleteHelpContent = contentId => async dispatch => {
  try {
    dispatch({
      type: DELETE_HELP_CONTENT_STARTED,
      contentId,
    });
    await deleteHelpContentApi(contentId);
    dispatch({
      type: DELETE_HELP_CONTENT_SUCCESS,
    });
    dispatch(fetchMainPageButtons(getPathnameForHelpContent()));
  } catch (error) {
    dispatch(fetchingError());
    dispatch({
      type: DELETE_HELP_CONTENT_FAILURE,
    });
    dispatch(errorNotification(error.message));
  }
};
